import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.css';

const MODAL_OPEN_CLASS = 'body--modal-open';
const Modal = ({ className, children }) => {
  useEffect(() => {
    document.body.classList.add(MODAL_OPEN_CLASS);

    return () => {
      document.body.classList.remove(MODAL_OPEN_CLASS);
    };
  }, []);

  return (
    <div className={`modal ${className}`}>
      <div className="shroud" />
      <div className="card">
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

Modal.defaultProps = {
  className: '',
  children: null,
};

export default Modal;
